module.exports = __webpack_public_path__ + "assets/4bc3b025547f1a2183b3ab1e5b86694c.png";